import { useIntl } from '@grandvisionhq/state';
import { PD_ALERT_TITLE_LABEL, PD_ALERT_MESSAGE_LABEL } from '../types.js';

const usePupillaryDistanceAlertLayout = ()=>{
    const { hasLabel  } = useIntl();
    return hasLabel(PD_ALERT_TITLE_LABEL) && hasLabel(PD_ALERT_MESSAGE_LABEL);
};

export { usePupillaryDistanceAlertLayout };
//# sourceMappingURL=use-pupillary-distance-alert-layout.js.map
